import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { declOfNum } from '../../common';

@inject('searchStore')
@observer
export default class SearchBox extends Component{

  searchInput = React.createRef();

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, false);
    document.removeEventListener('keydown', this.handleKeyDown, false);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, false);
    document.addEventListener('keydown', this.handleKeyDown, false);
  }

  handleInput = (e) => {
    this.props.searchStore.changeInput(e.target.value);
  }

  handleClickOutside = (e) => {
    const domNode = document.getElementById('search-box');
    if (e.path && !e.path.includes(domNode)) {
      this.props.searchStore.changeResultShowState(false);
    }
  }

  handleKeyDown = (e) => {
    const {data, keyIndex} = this.props.searchStore;

    if (!data.length) return;
    // arrow up/down button should select next/previous list element
    if (e.keyCode === 38 && keyIndex > 0) {
      this.props.searchStore.changeKeyIndex(keyIndex - 1);
      document.getElementById(`search-item-${keyIndex - 1 }`).focus();
    } else if (e.keyCode === 40 && keyIndex < data.length - 1) {
      this.props.searchStore.changeKeyIndex(keyIndex + 1);
      document.getElementById(`search-item-${keyIndex + 1 }`).focus();
    } else if (e.keyCode !== 9 && e.keyCode !== 16 && e.keyCode !== 13) {
      this.searchInput.current.focus();
    } 
  }

  handleClear = () => {
    this.props.searchStore.changeInput('');
    this.searchInput.current.focus();
  }

  handleFocus = () => {
    if(this.props.searchStore.data.length) {
      this.props.searchStore.changeResultShowState(true);
    }
  }

  render() {

    const {resultShow, data, loading, showClear, str} = this.props.searchStore;

    return(
      <div className="line-left-menu-search" id="search-box">
          <div className={`search-box-wrapper${loading ? ' line-search-loader' : ''}${showClear ? ' fill' : ''}`}>
              <div className="input-wrapper">
                  <input className="input" type="text" ref={this.searchInput} placeholder="Введите название лиги или команды" onChange={this.handleInput} onFocus={this.handleFocus} value={str} />
                  <div className="preloader">
                      <div className="cursor"></div>
                  </div>
                  <button className="clear" onClick={this.handleClear}>✖</button>
                  <span className="line-left-menu-search-icon f-s-ico-search"></span>
              </div>
              { resultShow ? <ResultSearch data={data}/> : ''}
          </div>
      </div>
    )
  }
}

@inject('searchStore')
@observer
class ResultSearch extends Component {

  componentDidMount() {
    document.getElementById(`search-item-${this.props.searchStore.keyIndex}`).focus();
  }

  render() {

    const {data} = this.props;
    const {showCurse, more, keyIndex} = this.props.searchStore;

    return(
      <div className="search-result">
        <div className="search-result-items">
          {data.map((item, idx) => 
            <Item key={item.id} item={item} index={keyIndex} id={idx}/>
          )}
        </div>
        {more ? 
          <div className="load-more">
            <span>Найдено ещё {more} {declOfNum(more,  ['событие', 'события', 'событий'])}. Уточните поиск</span>
          </div> 
        : ''}
        {showCurse ? 
          <div className="load-more">
            <span>Мы вас любим. Уточните поиск</span>
          </div> 
        : ''}
      </div>
    )
  }
}

@withRouter
@inject('searchStore')
@observer
class Item extends Component {

  handleClick = (url) => {
    this.props.history.push(url);
    this.props.searchStore.changeInput('');
  }

  render(){

    const {item, index, id} = this.props;
    const name = `${item.name.substr(0, item.cursor.begin)}<span className="cursor">${item.name.substr(item.cursor.begin, item.cursor.length)}</span>${item.name.substr(item.cursor.end, item.name.length - item.cursor.end)}`;
    const url = `/${item.live ? 'live' : 'line'}/${item.sid}/${item.type == 4 && item.lid ?  `${item.lid}/` : ''}${item.id}`;
    let preName = null;
    if (item.live && item.type === 4) {
        preName = (<span className="live f-s-ico-live"></span>);
    } else if (item.date && item.type === 4) {
        preName = (<span className="date">{item.date}</span>);
    }

    return(
      <a id={`search-item-${id}`} href="#" className={`item${item.type == 4 ? ' game' : ''}${index == id ? ' selected' : ''}`} onClick={() => this.handleClick(url)}>
        {!item.live ? <span className={`icon-sport f-s-ico-${item.sid}`}></span> : ''}
        {preName}
        <span className="name" dangerouslySetInnerHTML={{__html: name }}></span>
      </a>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/searchBox/index.jsx